import { render, staticRenderFns } from "./ArticlesManager.vue?vue&type=template&id=06ba1bb0&scoped=true&"
import script from "./ArticlesManager.vue?vue&type=script&lang=js&"
export * from "./ArticlesManager.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesManager.vue?vue&type=style&index=0&id=06ba1bb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba1bb0",
  null
  
)

export default component.exports